import { useContext } from "react";
import { Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { sqlDateToUSDate } from "../../sitel/commons/utilities/dates";
import { exemptionNameType, exemptionStatus } from "../../services/exemptions";
import AppContext from "../../services/appContext";
import nextActionMatrix, { possibleWizardSteps, stepToUrl } from "../../services/nextActionMatrix";
import DeleteRequestButtonWithConfirmationModal from "./DeleteOHRequestFlow";

export default function AllRequestsTable() {
    const appData = useContext(AppContext);

    return (
        <Table striped bordered hover className="mb-0 small">
            <thead className="bg-medstar-primary text-white">
                <tr>
                    <th>Exemption Request Name</th>
                    <th>Request Type</th>
                    <th>Date Submitted</th>
                    <th>Expiration Date</th>
                    <th>Approval Status</th>
                </tr>
            </thead>
            <tbody>
                {appData.userCurrentOhrequests.map(userOhrequest => {
                    return (
                        <tr key={userOhrequest.ohrequest_id}>
                            <td>{exemptionNameType[userOhrequest.ohrequest_type][1]}</td>
                            <td>{exemptionNameType[userOhrequest.ohrequest_type][0]}</td>
                            <td>{sqlDateToUSDate(userOhrequest.ohrequest_signature_date)}</td>
                            <td>{sqlDateToUSDate(userOhrequest.ohrequest_expires_at, 'n/a')}</td>
                            <td className="d-flex justify-content-between">{NextStepLink(userOhrequest)}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
}




//Next step is enabled when the user can take an action (usually on draft and more info needed)
//IF the status is draft, the next action can also be "delete the request" hence the condition
//around draft
function NextStepLink(userOhrequest) {

    const possibleNextAction = stepToUrl[nextActionMatrix(userOhrequest.ohrequest_status, userOhrequest.ohrequest_type, possibleWizardSteps.dashboard)];

    return (
        <>
            {
                possibleNextAction ? <>
                            <NavLink to={`${possibleNextAction}/${userOhrequest.ohrequest_type}/${userOhrequest.ohrequest_id}`}>
                                {exemptionStatus[userOhrequest.ohrequest_status].shortName}
                            </NavLink>
                            {exemptionStatus.draft.key === exemptionStatus[userOhrequest.ohrequest_status].key && (
                                <DeleteRequestButtonWithConfirmationModal requestId={userOhrequest.ohrequest_id}/>
                            )}
                    </>
                : <>{exemptionStatus[userOhrequest.ohrequest_status].shortName}</>
            }
        </>
    )
}




